/*
 * @Author: 汪永康 wangyongkang@yxj.org.cn
 * @Date: 2024-09-09 10:44:08
 * @LastEditors: 汪永康 wangyongkang@yxj.org.cn
 * @LastEditTime: 2024-11-20 16:31:30
 * @FilePath: \h5-lcjc-formula\src\utils\category\Neuro.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/** 神经病学 */

/** 对应的标题 */
const categoryMap = {
  Fisher: 'FISHER 分级',
  ASIA: 'ASIA 损伤分级',
  CincinattiStrokeScale: 'Cincinnati 院前脑卒中评分',
  ModifiedRankinScale: '改良Rankin分级',
  GlasgowOutcomeScale: 'Glasgow 结局分级',
  HuntHess: 'Hunt-Hess 分级',
  MuscleStrength: '肌力分级（MRC）',
  AMTS: '简易精神测试评分',
  AphasiaClassification: '失语分类',
  DermatomeMap: '皮节定位图',
  FVC_EyeChart: '视力表（Snellen）',
  WestHaven: 'WestHaven',
  StrengthGrading: '肌力分级法',
  Ashworth: '改良Ashworth痉挛评定',
  InjuryOfTheSpinalCord: 'ASIA损伤分级',
  ClinicalDiagnosticCriteriaForAD: '阿尔兹海默病（AD）临床诊断标准',
  NGASR: '自杀风险因素评估量表',
  China_Stroke_Scale: '中国脑卒中患者临床神经功能缺损评分',
  HAMD: '汉密尔顿抑郁量表',
  HIS: 'Hachinski缺血指数量表',
  SignsAndSymptomsOfCervicalNerveRootInvolvement: '颈神经根受累的症状和体征',
  DifferentialDiagnosisOfSpinalShockAndSpinalShock: '脊髓休克与脊髓震荡的鉴别',
  YoungManiaRatingScale: '年轻人躁狂症评定表（YMRS）',
  MiniMentalStateExamination: '简易智能精神状态检查量表（MMSE）',
  CerebralPerfusionPressure: '脑灌注压（CPP）',
  NIHSS: '美国独立卫生院卒中量表（NIHSS）',
  PittsburghBrainStemScore: '匹兹堡脑干评分',
  PVS: '持续性植物状态评分PVS表',
  ASRAAOL: '缺血性卒中的ASTRAL量表评分',
  NeuropathicPainScale: '神经病变疼痛量表(NPS)',
  PNSC: '神经系统副肿瘤综合征PNS诊断标准',
  SMCOIAM: '颅内血管动静脉畸形Spetsler-Martin分级',
  TIAScore: 'TIA预后: 发病后90天内中风风险',
  CTMRIfindingsofChiarimalformation: '小脑扁桃体下疝Chiari畸形CT/MRI表现',
  Chiarimalformationclassification: '小脑扁桃体下疝Chiari畸形分型',
  Clinicalclassificationofmultiplesclerosis: '多发性硬化的临床分型',
  TheOutcomeGradingOfGlasgow: 'Glasgow结局分级',
  Skeletalmusclestrengthtestingmethods: '骨骼肌肌力检查方法',
  InternationalClassificationofHeadacheDisorders: '偏头痛的诊断标准（ICHD-3）',
  Cluster_headache: '丛集性头痛诊断标准',
  DN_four: 'DN4评分',
  Carotid_Artery_Stenosis: '颈动脉血管狭窄分级（NASCET法）',
  Spinal_disorders_of_different_sites: '不同部位脊髓疾病的症状和诊断',
  Phenobarbital: '苯巴比妥',
  Valproic_acid: '丙戊酸',
  Human_Epididymis_Protein_four: '人附睾蛋白4（HE4）',
  Carbamazepine: '卡马西平',
  Acetaminophen: '对乙酰氨基酚',
  Glutamic_Acid: '谷氨酸',
  Homocysteine: '同型半胱氨酸（Hcy）',
  Creatine_Kinase: '肌酸激酶（CK）',
  Aldolase: '醛缩酶（ALD）',
  S100_protein: 'S100蛋白',
  Cobalamin: '维生素B12（钴胺素）'
}
/** 对应的描述 */
const categoryDescMap = {
  Fisher: '蛛网膜下腔出血分级系统',
  ASIA: '美国脊髓损伤协会',
  CincinattiStrokeScale: '简单鉴别脑卒中症状',
  ModifiedRankinScale: '神经系统事件后的残疾程度',
  GlasgowOutcomeScale: '神经系统事件后的残疾程度',
  HuntHess: '蛛网膜下腔出血分级',
  MuscleStrength: '肌力评估',
  AMTS: '对老年患者的快速评估',
  AphasiaClassification: 'Wernicke 失语、Broca失语还是传导性失语',
  DermatomeMap: '参考图表',
  FVC_EyeChart: '视力检测工具',
  StrengthGrading: '6级肌力分级标准表',
  Ashworth: '临床常用的痉挛量化评估量表',
  CTMRIfindingsofChiarimalformation: '评估Chiari畸形CT/MRI表现',
  Chiarimalformationclassification: '评估Chiari畸形分型',
  Clinicalclassificationofmultiplesclerosis: '评估多发性硬化如何分型',
  TheOutcomeGradingOfGlasgow: '神经系统事件后残疾程度分级',
  Skeletalmusclestrengthtestingmethods: '常见骨骼肌肌力检查',
  DN_four: '评估神经病理性疼痛',
  Carotid_Artery_Stenosis: '评估颈动脉狭窄程度'
}

/** 没有公式描述的页面 */
const categoryNotInfoMap = {
  FVC_EyeChart: 'FVC_EyeChart',
  WestHaven: 'WestHaven'
}
export default {
  categoryMap,
  categoryDescMap,
  categoryNotInfoMap
}



// WEBPACK FOOTER //
// ./src/utils/category/Neuro.js